import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@common/encoding';
import { PermissionsByRole } from './PermissionsByRole.js';
export class GroupPrivateSettings extends AutoEncoder {
    defaultEmailId = null;
    /**
     * Default setting for admin registrations:
     * send an email to members when an admin registers a member
     */
    sendConfirmationEmailForManualRegistrations = false;
    permissions = PermissionsByRole.create({});
}
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 10 })
], GroupPrivateSettings.prototype, "defaultEmailId", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 378 })
], GroupPrivateSettings.prototype, "sendConfirmationEmailForManualRegistrations", void 0);
__decorate([
    field({ decoder: PermissionsByRole, version: 60, optional: true })
], GroupPrivateSettings.prototype, "permissions", void 0);
export const GroupPrivateSettingsPatch = GroupPrivateSettings.patchType();
//# sourceMappingURL=GroupPrivateSettings.js.map